import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import translate from '@/lib/intl/translate';
import type ConstituentIWaveProfile from '@/types/api/ConstituentIWaveProfile';
import { formatCurrency } from '@/utils/currency';

// import { formatDate } from '@/utils/dates';

// import IWaveScore from '../constants/IWaveScore';
// import IWaveScoreEvaluation from './IWaveScoreEvaluation';

export default function ConstituentIWaveDetailedSummary({
  iwaveProfile,
}: {
  iwaveProfile: ConstituentIWaveProfile;
}) {
  const [isDetailedSummaryExpanded, setIsDetailedSummaryExpanded] =
    React.useState(false);
  // const [isGivingBreakdownExpanded, setIsGivingBreakdownExpanded] =
  //   React.useState(false);
  const dlClassName = 'grid type-body1 grid-cols-[300px_1fr] gap-x-8 gap-y-3';

  return (
    <div>
      <h2 className="mb-4 type-h2">
        {translate('IWAVE_DETAILED_SUMMARY_HEADER')}
      </h2>

      <Accordion
        className="mb-4 rounded-lg border border-grey-300 shadow-none"
        expanded={isDetailedSummaryExpanded}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowDownIcon />}
          onClick={() =>
            setIsDetailedSummaryExpanded(!isDetailedSummaryExpanded)
          }
        >
          <h3 className="type-body2">
            {translate('IWAVE_DETAILED_SUMMARY_OVERVIEW_SUBHEADER')}
          </h3>
        </AccordionSummary>

        <AccordionDetails>
          <dl className={dlClassName}>
            {iwaveProfile?.largestEstimatedCapacity && (
              <>
                <dt>
                  {translate('IWAVE_DETAILED_SUMMARY_LARGEST_ESTIMATE_TERM')}
                </dt>
                <dd>
                  {formatCurrency(iwaveProfile?.largestEstimatedCapacity, true)}
                </dd>
              </>
            )}

            {iwaveProfile?.realEstateTotalValue && (
              <>
                <dt>{translate('IWAVE_DETAILED_SUMMARY_REAL_ESTATE_TERM')}</dt>
                <dd>
                  {formatCurrency(iwaveProfile.realEstateTotalValue, true)}
                </dd>
              </>
            )}

            {iwaveProfile?.totalReleaseProperties && (
              <>
                <dt>
                  {translate(
                    'IWAVE_DETAILED_SUMMARY_TOTAL_RELEASE_PROPERTIES_TERM',
                  )}
                </dt>
                <dd>{iwaveProfile.totalReleaseProperties}</dd>
              </>
            )}

            {/* these are not available from iwave yet. commenting out until they are...
            <dt>
              {translate('IWAVE_DETAILED_SUMMARY_BASE_COMPENTATION_TERM')}
            </dt>
            <dd>{formatCurrency(13500000, true)}</dd>

            <dt>{translate('IWAVE_DETAILED_SUMMARY_SCORE_TERM')}</dt>
            <dd>
              <IWaveScoreEvaluation score={IWaveScore.GOOD} />
            </dd>
            */}
          </dl>
        </AccordionDetails>
      </Accordion>

      {/**
        MUI has some base `:before` styles for when accordions are rendered next 
        to each other. We don't want those here, so using `before:h-0` to squash
        the pseudo element.
      */}
      {/* these are not available from iwave yet. commenting out until they are...
      <Accordion
        className="rounded-lg border border-grey-300 shadow-none before:h-0"
        expanded={isGivingBreakdownExpanded}
      >
        <AccordionSummary
          expandIcon={<KeyboardArrowDownIcon />}
          onClick={() =>
            setIsGivingBreakdownExpanded(!isGivingBreakdownExpanded)
          }
        >
          <h3 className="type-body2">
            {translate('IWAVE_DETAILED_SUMMARY_GIVING_BREAKDOWN_SUBHEADER')}
          </h3>
        </AccordionSummary>

        <AccordionDetails>
          <dl className={dlClassName}>
            <dt>{translate('IWAVE_DETAILED_SUMMARY_RECENT_GIFT_TERM')}</dt>
            <dd>
              {translate('IWAVE_DETAILED_SUMMARY_AMOUNT_DATE_DETAILS', {
                amount: formatCurrency(2500000, true),
                date: formatDate('2023-01-01'),
              })}
            </dd>

            <dt>{translate('IWAVE_DETAILED_SUMMARY_LARGEST_GIFT_TERM')}</dt>
            <dd>
              {translate('IWAVE_DETAILED_SUMMARY_AMOUNT_DATE_DETAILS', {
                amount: formatCurrency(2500000, true),
                date: formatDate('2023-01-01'),
              })}
            </dd>

            <dt>
              {translate('IWAVE_DETAILED_SUMMARY_TOTAL_GIFTS_NUMBER_TERM')}
            </dt>
            <dd>10</dd>

            <dt>
              {translate('IWAVE_DETAILED_SUMMARY_TOTAL_GIFTS_AMOUNT_TERM')}
            </dt>
            <dd>{formatCurrency(2500000, true)}</dd>
          </dl>
        </AccordionDetails>
      </Accordion>
      */}
    </div>
  );
}
